import { Component, Input, computed, signal } from '@angular/core';

@Component({
  selector: 'app-star-rating',
  standalone: true,
  template: `
    <span class="inline-flex items-center gap-0.5 text-gold" aria-hidden="true">
      @for (i of stars(); track i) {
        <svg viewBox="0 0 20 20" fill="currentColor" class="h-4 w-4">
          <path
            d="M10 1.5l2.6 5.27 5.82.85-4.21 4.1 1 5.8L10 14.9l-5.21 2.74 1-5.8-4.21-4.1 5.82-.85L10 1.5z"
          />
        </svg>
      }
    </span>
  `,
})
export class StarRatingComponent {
  private readonly ratingSignal = signal(0);

  @Input() set rating(value: number | string | null | undefined) {
    this.ratingSignal.set(Number(value) || 0);
  }

  readonly stars = computed(() => {
    const rounded = Math.round(this.ratingSignal());
    return Array.from({ length: Math.max(0, Math.min(5, rounded)) });
  });
}
